define('views/components/recurring_customer_product_compact/recurring_products',['require','views/base/collection_view','views/components/recurring_customer_product_compact/recurring_product_list','text!templates/components/recurring_customer_product_compact/recurring_products.html'],function(require){

    var BaseCollectionView = require('views/base/collection_view');
    var ListView = require('views/components/recurring_customer_product_compact/recurring_product_list');

    var temp = require("text!templates/components/recurring_customer_product_compact/recurring_products.html");
    return BaseCollectionView.extend({
        template: _.template(temp),
        className: 'grid-container recurring-product-grid-container',

        onRender: function () {
            this.ListContainer.show(new ListView({
                collection: this.collection
            }));
        }
    });
});

